import CloseIcon from '@mui/icons-material/Close'
import {DialogCustomStyled, DialogPaperStyled} from './DialogCustomStyled'
import {Breakpoint, DialogActions, DialogContent, DialogTitle, IconButton, SxProps, Theme, Typography} from '@mui/material'
import {FormattedMessage} from 'react-intl'

type DialogCustomProps = {
  open?: boolean,
  title?: {text: string, format: boolean},
  body: React.ReactNode,
  footer?: React.ReactNode,
  maxWidth?: Breakpoint,
  onClose?: () => void,
  disableShadow?: any,
  // Lets callers raise the dialog's z-index (e.g. when opened from inside a
  // components-new Filters drawer, whose own z-index sits above the default
  // MUI modal layer — see FILTERS_POPUP_Z_INDEX in components-new/data/Filters.tsx).
  sx?: SxProps<Theme>
}

const DialogCustom: React.FC<DialogCustomProps> = ({open = true, title, body, footer = <></>, maxWidth, onClose, disableShadow, sx}) => {
  // Il click fuori dal dialog non lo chiude: si chiude solo con la X (o Esc),
  // per non perdere quanto compilato con un click accidentale.
  const handleRootClose = (_event: unknown, reason: string) => {
    if (reason === 'backdropClick') return
    onClose?.()
  }

  return (
    // @ts-ignore
    <DialogCustomStyled disableShadow={disableShadow} fullWidth maxWidth={maxWidth} onClose={handleRootClose} open={open} sx={sx}>
      <DialogPaperStyled>
        <DialogTitle>
          <div className='dialog-header'>
            <Typography className='dialog-title' variant='h1'>{title?.format ? <FormattedMessage id={title.text} /> : <>{title?.text}</>}</Typography>
            <IconButton aria-label='close' edge='end' onClick={onClose} style={{backgroundColor: 'transparent'}}>
              <CloseIcon fontSize='small' />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className='dialog-body'>
            {body}
          </div>
        </DialogContent>
        <DialogActions>
          <div className='dialog-footer'>
            {footer}
          </div>
        </DialogActions>
      </DialogPaperStyled>
    </DialogCustomStyled>
  )
}

export default DialogCustom
